import { createApp } from 'vue';
import NefToPngConverter from '../Components/NefToPngConverter.vue';

const root = document.getElementById('nef-to-png-converter');
if (root) {
  createApp(NefToPngConverter).mount('#nef-to-png-converter');
}
